import { Trans, Plural } from '@lingui/react/macro'
import { WandSparkles } from 'lucide-react'

export const ErrorCorrectionStats = ({
  rowCount,
  errorCount,
  correctedCount,
}: {
  rowCount: number
  errorCount: number
  correctedCount: number
}) => {
  return (
    <div className="flex items-center gap-3 text-sm text-black">
      <WandSparkles size={18} className="text-cv-ai-purple" />
      <div>
        <Trans comment="Information about how many errors were corrected across dataset rows, in the context of the error correction tool">
          Corrected <span className="font-medium">{correctedCount}</span> of{' '}
          <span className="font-medium">{errorCount}</span>{' '}
          <Plural value={errorCount} one="error" other="errors" /> in{' '}
          <Plural value={rowCount} one="1 row" other="# rows" />
        </Trans>
      </div>
    </div>
  )
}
